import { render, staticRenderFns } from "./DataViewSidebarRecommendedSefetyMeasures.vue?vue&type=template&id=8ab1f26c&scoped=true&"
import script from "./DataViewSidebarRecommendedSefetyMeasures.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarRecommendedSefetyMeasures.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarRecommendedSefetyMeasures.vue?vue&type=style&index=0&id=8ab1f26c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab1f26c",
  null
  
)

export default component.exports